export const UNIT_STATE_DEPLOYED = 'deployed';
export const UNIT_STATE_IN_BAG = 'in_bag';
export const UNIT_STATE_IN_HAND = 'in_hand';
export const UNIT_STATE_IN_SUPPLY = 'in_supply';
export const UNIT_STATE_IN_RESERVE = 'in_reserve';
export const UNIT_STATE_ELIMINATED = 'eliminated';
export const UNIT_STATE_RECRUITED = 'recruited';
export const UNIT_STATE_TOP_OF_BAG = 'top_of_bag';
export const UNIT_STATE_DISCARDED_FACEDOWN = 'discarded_facedown';
export const UNIT_STATE_DISCARDED_FACEUP = 'discarded_faceup';

export const UNIT_TYPE_ADMIRAL = 'ADMIRAL';
export const UNIT_TYPE_ALCHEMIST = 'ALCHEMIST';
export const UNIT_TYPE_APPRENTICE = 'APPRENTICE';
export const UNIT_TYPE_ARCHER = 'ARCHER';
export const UNIT_TYPE_ASSASSIN = 'ASSASSIN';
export const UNIT_TYPE_BANNERMAN = 'BANNERMAN';
export const UNIT_TYPE_BERSERKER = 'BERSERKER';
export const UNIT_TYPE_BERSERKER_V2 = 'BERSERKER_V2';
export const UNIT_TYPE_BISHOP = 'BISHOP';
export const UNIT_TYPE_SABOTEUR = 'SABOTEUR';
export const UNIT_TYPE_CAVALRY = 'CAVALRY';
export const UNIT_TYPE_COMMANDER = 'COMMANDER';
export const UNIT_TYPE_CROSSBOWMAN = 'CROSSBOWMAN';
export const UNIT_TYPE_DRAGOON = 'DRAGOON';
export const UNIT_TYPE_EARL = 'EARL';
export const UNIT_TYPE_EMISSARY = 'EMISSARY';
export const UNIT_TYPE_EMISSARY_V2 = 'EMISSARY_V2';
export const UNIT_TYPE_ENSIGN = 'ENSIGN';
export const UNIT_TYPE_FOOTMAN = 'FOOTMAN';
export const UNIT_TYPE_FOOTMAN_V2 = 'FOOTMAN_V2';
export const UNIT_TYPE_HEAVY_CAVALRY = 'HEAVY_CAVALRY';
export const UNIT_TYPE_HERALD = 'HERALD';
export const UNIT_TYPE_INFILTRATOR = 'INFILTRATOR';
export const UNIT_TYPE_KNIGHT = 'KNIGHT';
export const UNIT_TYPE_LANCER = 'LANCER';
export const UNIT_TYPE_LIGHT_CAVALRY = 'LIGHT_CAVALRY';
export const UNIT_TYPE_CORSAIR = 'CORSAIR';
export const UNIT_TYPE_OVERLORD = 'OVERLORD';
export const UNIT_TYPE_MARKSMAN = 'MARKSMAN';
export const UNIT_TYPE_MARSHAL = 'MARSHAL';
export const UNIT_TYPE_MERCENARY = 'MERCENARY';
export const UNIT_TYPE_PIKEMAN = 'PIKEMAN';
export const UNIT_TYPE_PIRATE = 'PIRATE';
export const UNIT_TYPE_PITCH_THROWER = 'PITCH_THROWER';
export const UNIT_TYPE_RAIDER = 'RAIDER';
export const UNIT_TYPE_HUN = 'HUN';
export const UNIT_TYPE_REARGUARD = 'REARGUARD';
export const UNIT_TYPE_ROYAL_COIN = 'ROYAL_COIN';
export const UNIT_TYPE_ROYAL_COIN_BLACK = 'ROYAL_COIN_BLACK';
export const UNIT_TYPE_ROYAL_COIN_WHITE = 'ROYAL_COIN_WHITE';
export const UNIT_TYPE_ROYAL_GUARD = 'ROYAL_GUARD';
export const UNIT_TYPE_ROYAL_GUARD_NOBILITY = 'ROYAL_GUARD_NOBILITY';
export const UNIT_TYPE_SAPPER = 'SAPPER';
export const UNIT_TYPE_SCOUT = 'SCOUT';
export const UNIT_TYPE_DECOY_COIN = 'DECOY_COIN';
export const UNIT_TYPE_DECOY_COIN_INFILTRATOR = 'DECOY_COIN_INFILTRATOR';
export const UNIT_TYPE_DECOY_COIN_SKIRMISHER = 'DECOY_COIN_SKIRMISHER';
export const UNIT_TYPE_RANGER = 'RANGER';
export const UNIT_TYPE_SIEGE_TOWER = 'SIEGE_TOWER';
export const UNIT_TYPE_SKIRMISHER = 'SKIRMISHER';
export const UNIT_TYPE_SWORDSMAN = 'SWORDSMAN';
export const UNIT_TYPE_TREBUCHET = 'TREBUCHET';
export const UNIT_TYPE_TREBUCHET_V2 = 'TREBUCHET_V2';
export const UNIT_TYPE_TREBUCHET_V3 = 'TREBUCHET_V3';
export const UNIT_TYPE_VANGUARD = 'VANGUARD';
export const UNIT_TYPE_WARLORD = 'WARLORD';
export const UNIT_TYPE_WAR_DRUMMER = 'WAR_DRUMMER';
export const UNIT_TYPE_WAR_WAGON = 'WAR_WAGON';
export const UNIT_TYPE_LONGBOAT = 'LONGBOAT';
export const UNIT_TYPE_WARRIOR_PRIEST = 'WARRIOR_PRIEST';
export const UNIT_TYPE_WARRIOR_PRIEST_V2 = 'WARRIOR_PRIEST_V2';

export const baseUnits = [
    UNIT_TYPE_ARCHER,
    // UNIT_TYPE_BERSERER,
    UNIT_TYPE_BERSERKER_V2,
    UNIT_TYPE_CAVALRY,
    UNIT_TYPE_CROSSBOWMAN,
    UNIT_TYPE_ENSIGN,
    // UNIT_TYPE_FOOTMAN,
    UNIT_TYPE_FOOTMAN_V2,
    UNIT_TYPE_KNIGHT,
    UNIT_TYPE_LANCER,
    UNIT_TYPE_LIGHT_CAVALRY,
    UNIT_TYPE_MARSHAL,
    UNIT_TYPE_MERCENARY,
    UNIT_TYPE_PIKEMAN,
    UNIT_TYPE_ROYAL_GUARD,
    UNIT_TYPE_SCOUT,
    UNIT_TYPE_SWORDSMAN,
    // UNIT_TYPE_WARRIOR_PRIEST,
    UNIT_TYPE_WARRIOR_PRIEST_V2,
];

export const nobilityUnitTypes = [
    UNIT_TYPE_BANNERMAN,
    UNIT_TYPE_BISHOP,
    UNIT_TYPE_HERALD,
    UNIT_TYPE_EARL,
];

export const siegeUnitTypes = [
    UNIT_TYPE_SIEGE_TOWER,
    UNIT_TYPE_WAR_WAGON,
    // UNIT_TYPE_TREBUCHET,
    // UNIT_TYPE_TREBUCHET_V2,
    UNIT_TYPE_TREBUCHET_V3,
    UNIT_TYPE_SAPPER,
];

export const nightfallUnitTypes = [
    UNIT_TYPE_ASSASSIN,
    UNIT_TYPE_SABOTEUR,
    UNIT_TYPE_INFILTRATOR,
    UNIT_TYPE_SKIRMISHER,
];

export const masteryUnitTypes = [
    UNIT_TYPE_ALCHEMIST,
    UNIT_TYPE_APPRENTICE,
    UNIT_TYPE_EMISSARY_V2,
    UNIT_TYPE_OVERLORD,
];

export const highSeasUnitTypes = [
	UNIT_TYPE_CORSAIR,
	UNIT_TYPE_LONGBOAT,
	UNIT_TYPE_PIRATE,
	UNIT_TYPE_ADMIRAL,
];

export const shockUnitTypes = [
    UNIT_TYPE_RAIDER,
    UNIT_TYPE_REARGUARD,
    UNIT_TYPE_PITCH_THROWER,
    UNIT_TYPE_WAR_DRUMMER,
];

export const championsUnitTypes = [
    UNIT_TYPE_COMMANDER,
	UNIT_TYPE_DRAGOON,
	UNIT_TYPE_MARKSMAN,
	UNIT_TYPE_RANGER,
];

export const officialUnits = [
    ...baseUnits,
    ...nobilityUnitTypes,
    ...nightfallUnitTypes,
    ...siegeUnitTypes,
];

export const altUnitTypes = [
    UNIT_TYPE_WARLORD,
    UNIT_TYPE_HEAVY_CAVALRY,
    UNIT_TYPE_VANGUARD,
];

export const unitTypes = [
    ...officialUnits,
    ...masteryUnitTypes,
	...highSeasUnitTypes,
    ...shockUnitTypes,
    ...altUnitTypes,
];

interface IAction {
    type: any;
    description?: string;
    unitId?: number;
    friendlyUnitId?: number;
    friendlyUnitIds?: number[];
    opponentUnitId?: number;
    targetPositions?: string[];
    options?: any[];
    secondaryActionId: number;
}

export interface IUnit {
    id: number;
    playerId: number;
    position: string;
    state: string;
    imageName: string;
    name: string;
    type: string;
    typeId: number;
    quantity: number;
    parentUnitId: number;
    actions: IAction[];
    bolsterUnits: IUnit[];
}

export interface IUnitType {
    id: number;
    name: string;
    type: string;
    className: string;
    imageName: string;
    quantity: number;
    playerId: number;
}

export interface IUnitTypeResource {
    id: number;
    name: string;
    type: string;
    imageName: string;
}
